module.exports = __webpack_public_path__ + "static/email-template-trial-ended-014ac128dda7173cdcdf1186adc6f7bb.png";